import { Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { Validator } from '../core/model/validator';
import { ValidatorBase } from '../core/model/validator-base';

@Directive({
    selector: '[required-field-validator]',
    host: { '(change)': 'changed($event)' },
    exportAs: 'validator'
})
export class RequiredFieldValidatorDirective extends ValidatorBase implements OnInit, Validator
{
    @Input('required-field-validator')
    public getValue: () => string;

    public valid: boolean;

    public constructor(viewRef: ViewContainerRef)
    {
        super(viewRef);
    }

    public changed(event: any): void
    {
        this.validate();
    }

    protected isValid(): boolean
    {
        const data = this.removeIllegalCharacters(this.elementRef.value);
        return data.value.length > 0 && !data.hasError;
    }

    public ngOnInit(): void { }
}
